<template>
    <div
      v-if="visible"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 px-4"
      @click.self="closeModal"
    >
      <!-- Modal -->
      <div
        class="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden shadow-2xl"
      >
  
        <!-- Close button -->
        <button
          type="button"
          @click="closeModal"
          class="absolute top-3 right-3 z-20 flex items-center justify-center
                 w-10 h-10 rounded-full
                 bg-black bg-opacity-70
                 text-white
                 hover:bg-opacity-90
                 focus:outline-none"
          aria-label="Close video"
        >
          <svg
            class="w-6 h-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 6l12 12M18 6L6 18"
            />
          </svg>
        </button>
  
        <!-- Video -->
        <video
          v-if="videoUrl"
          ref="video"
          :src="videoUrl"
          controls
          autoplay
          playsinline
          preload="metadata"
          class="block w-full max-h-[80vh] bg-black"
          @ended="onVideoEnded"
          @error="onVideoError"
          @playing="onVideoPlaying"
        >
          Your browser does not support the video tag.
        </video>
  
        <!-- Loading -->
        <div
          v-if="videoUrl && isLoading"
          class="absolute inset-0 flex items-center justify-center pointer-events-none"
        >
          <div
            class="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin"
          ></div>
        </div>
  
        <!-- Error -->
        <div
          v-if="videoError"
          class="flex flex-col items-center justify-center p-10 text-center text-white"
        >
          <svg
            class="w-12 h-12 mb-4 text-red-400"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="12" cy="12" r="9" />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 8v4M12 16h.01"
            />
          </svg>
  
          <p class="text-lg font-semibold">
            Unable to play this video
          </p>
  
          <p class="text-sm text-gray-300 mt-1">
            Please try again later.
          </p>
  
          <button
            type="button"
            @click="closeModal"
            class="mt-5 px-5 py-2 rounded-md bg-indigo-600 text-white font-semibold hover:bg-indigo-700"
          >
            Close
          </button>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ReductionVideoModal',
  
    props: {
      visible: {
        type: Boolean,
        default: false
      },
  
      videoUrl: {
        type: String,
        default: ''
      }
    },
  
    data() {
      return {
        isLoading: true,
        videoError: false
      }
    },
  
    watch: {
      visible(value) {
        if (value) {
          this.isLoading = true
          this.videoError = false
  
          this.$nextTick(() => {
            if (this.$refs.video) {
              this.$refs.video.load()
  
              const playPromise = this.$refs.video.play()
  
              if (playPromise !== undefined) {
                playPromise.catch(() => {
                  // Browser may block autoplay.
                  // Controls are still available.
                })
              }
            }
          })
        } else {
          this.stopVideo()
        }
      },
  
      videoUrl() {
        this.isLoading = true
        this.videoError = false
      }
    },
  
    methods: {
      closeModal() {
        this.stopVideo()
        this.$emit('close')
      },
  
      stopVideo() {
        const video = this.$refs.video
  
        if (video) {
          video.pause()
          video.currentTime = 0
          video.removeAttribute('src')
          video.load()
        }
      },
  
      onVideoEnded() {
        // Optional:
        // Video has finished playing.
      },

      onVideoPlaying() {
        this.isLoading = false
      },
  
      onVideoError() {
        this.isLoading = false
        this.videoError = true
      }
    },
  
    beforeDestroy() {
      this.stopVideo()
    }
  }
  </script>